"use strict";function removeItem$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.removeItem$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="util.domainStorage.removeItem";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.9.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.9.0"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"4.6.29"},_a)),exports.removeItem$=removeItem$,exports.default=removeItem$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/util/domainStorage/removeItem.js
// module id = 1104
// module chunks = 106